var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dial-code-item compact-text",class:{ actionable: _vm.actionable, selected: _vm.selected, mobile: _vm.mobile }},[_c('span',{staticClass:"item-flag -mr_1",style:(`background: url(${_vm.flag});`)}),_c('span',{staticClass:"item-text"},[_c('span',{staticClass:"item-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }